"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.knowledge.updated': 'Base de conocimiento del avatar actualizada exitosamente',
    'avatar.knowledge.load.error': 'Error al cargar la base de conocimiento del avatar',
    'avatar.knowledge.update.error': 'Error al actualizar la base de conocimiento del avatar',
};
